import React from "react";
import { useHardCode } from "../../hooks";
import { useSelector } from "react-redux";
export const ContactInfoCard = ({ toggleModal, className }) => {
  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const comma = ",";
  const customerAddress1 = productDetailsState?.customerInfo?.customer_address1
    ? productDetailsState?.customerInfo?.customer_address1 + comma
    : "";
  const customerAddress2 = productDetailsState?.customerInfo?.customer_address2
    ? productDetailsState?.customerInfo?.customer_address2 + comma
    : "";
  const customerCity = productDetailsState?.customerInfo?.customer_city
    ? productDetailsState?.customerInfo?.customer_city + comma
    : "";
  const customerState = productDetailsState?.customerInfo?.customer_state
    ? productDetailsState?.customerInfo?.customer_state + comma
    : "";
  const customerZip = productDetailsState?.customerInfo?.customer_zip
    ? productDetailsState?.customerInfo?.customer_zip + comma
    : "";
  const countryName = productDetailsState?.customerInfo?.country_name
    ? productDetailsState?.customerInfo?.country_name
    : "";
  const fullAddress =
    customerAddress1 +
    customerAddress2 +
    customerCity +
    customerState +
    customerZip +
    countryName;
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isStorePureFemale =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const CONTACT_INFORMATION = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.contact_information
    : storeConfigState?.themeConfig?.shipping_information;
  const EDIT = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.edit
    : storeConfigState?.themeConfig?.edit;
  const FROM_ADDRESS = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.from_address
    : "";

  return (
    <div className={`${className} contact-card-content`}>
      <div className="contact-card-heading">
        <div>{CONTACT_INFORMATION}</div>
        <div>
          <span className="edit_modal" onClick={toggleModal}>
            {EDIT}
          </span>
        </div>
      </div>
      <div className="contact-input">
        <input
          type="email"
          placeholder={storeConfigState?.themeConfig?.email}
          value={productDetailsState?.customerInfo?.customer_email}
          className="saara_email"
          readOnly
        />
        <input
          type="text"
          placeholder={storeConfigState?.themeConfig?.phone}
          value={productDetailsState?.customerInfo?.customer_contact}
          className="saara_phone"
          readOnly
        />
      </div>
      <div className="contact-address">
        <div className="address-heading">{FROM_ADDRESS}</div>
        <div className="address-input">
          <input
            type="text"
            value={fullAddress.replace(/,/g, ", ")}
            className="full-address"
            size="50"
            readOnly
          />
        </div>
      </div>
    </div>
  );
};
